import { render } from "./paginated-scroll-area.vue?vue&type=template&id=112f72f9"
import script from "./paginated-scroll-area.vue?vue&type=script&setup=true&lang=js"
export * from "./paginated-scroll-area.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/components/paginated-scroll-area.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "112f72f9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('112f72f9', __exports__)) {
    console.log('reload')
    api.reload('112f72f9', __exports__)
  }
  
  module.hot.accept("./paginated-scroll-area.vue?vue&type=template&id=112f72f9", () => {
    console.log('re-render')
    api.rerender('112f72f9', render)
  })

}


export default __exports__